import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import {
  CompanyProfileInsight, insightConfidenceColour, insightConfidenceLabel,
  PROFILE_INSIGHT_CARD_LIST_HEADER_COLOUR, PROFILE_INSIGHT_CHART_COLOURS, PROFILE_INSIGHT_GAUGE_COLOUR,
} from './profile-insight';

// Shared Magic Insights card for the skinned company profiles: eyebrow, title, the answer rendered by display
// type and a footer with confidence and an evidence button. Colours default to the Logistics skin and come
// from the --profile-insight-* custom properties. The parent owns the evidence dialog and opens it from (viewEvidence).
@Component({
  selector: 'company-profile-insight-card',
  templateUrl: './company-profile-insight-card.component.html',
  styleUrls: ['./company-profile-insight-card.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CompanyProfileInsightCardComponent {
  @Input({ required: true }) insight!: CompanyProfileInsight;
  @Input() chartColours = PROFILE_INSIGHT_CHART_COLOURS;
  @Input() gaugeColour = PROFILE_INSIGHT_GAUGE_COLOUR;
  @Input() cardListHeaderColour = PROFILE_INSIGHT_CARD_LIST_HEADER_COLOUR;
  @Input() listLimit = 4;
  @Input() eyebrowIconClass = 'fal fa-sparkles';
  /** Show the confidence in the footer. Skins that show it on a group heading can replace it with [footNote]. */
  @Input() showConfidence = true;
  @Input() footNote = '';
  @Input() evidenceLabel = 'View evidence';
  @Output() viewEvidence = new EventEmitter<CompanyProfileInsight>();

  readonly confidenceLabel = insightConfidenceLabel;
  readonly confidenceColour = insightConfidenceColour;

  get isChart(): boolean {
    return ['vertical_bar_chart', 'pie_chart', 'gauge'].includes(this.insight.displayType);
  }

  get isCompact(): boolean {
    return ['likelihood', 'amount', 'records', 'chips', 'notes', 'bars', 'breakdown', 'text'].includes(this.insight.displayType);
  }
}
